import { Component, Input, OnInit } from '@angular/core';
import { OrdersService } from '../../___LOGIC/__orders/orders.service';
import { ShopifyService } from '../../___LOGIC/__shopify/shopify.service';
import { GuiFlowService } from '../../___LOGIC/__gui/gui-flow.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pdf-guide-sell',
  templateUrl: './pdf-guide-sell.component.html',
  styleUrls: ['./pdf-guide-sell.component.css']
})
export class PdfGuideSellComponent implements OnInit {

  @Input() guide: {
    title: string;
    description: string;
    imageUrl: string;
    shopifyLink: string;
    variantId: number,
    variantLabel: string
  };
  
  showGuideDetails = false;
  cardStatus = '';
  processStatus = 0;
  // LOADING MODAL
  loadingStep: 'spinner' | 'confirmation' = 'spinner';
  loadingMessage = 'Procesando, por favor espera...';
  
  constructor(private ordersService: OrdersService,private shopifyService: ShopifyService,private guiFlow: GuiFlowService,private router: Router) { }

  ngOnInit(): void {
    /* this.guiFlow.showSpinnerModal('Procesando'); */
    /* this.guiFlow.showPaymentReceivedModal('Pago recibido'); */
  }

  isStatus(s){
    return this.cardStatus == s;
  }

  buyProduct(myVariantLabel){
    this.guiFlow.showSpinnerModal('Procesando pedido');
    this.ordersService.buyProduct(myVariantLabel).subscribe({
      next: (response) => {
        if (response && response.OK) {
          let orderObject = {
            'productVariantId': this.guide.variantId
          };
          response.OK.records.FK_ID_clientDetails? orderObject['user_id'] = response.OK.records.FK_ID_clientDetails : null; // In case user is logged in
          this.shopifyService.buyProduct(orderObject);
          this.checkIsOrderProcessed(response.OK.records.orderCode);
        } else {
          console.log('Order creation failed:',);
        }
      },
      error: (error) => {
        this.guiFlow.openSimpleSnackBar('Error, intentalo de nuevo','error',null,'');
        console.log('HTTP request failed:', error);
      }
    })
  }

  checkIsOrderProcessed(orderId){
    this.ordersService.checkIsOrderProcessed(orderId).subscribe({
      next: (result) => {
        if (result && result.status === 'paid') {
          this.processStatus = 1;
          this.cardStatus = 'paid';
          this.guiFlow.showPaymentReceivedModal('Pago recibido');
          setTimeout(() => {
            this.guiFlow.hideModal();
          }, 2000);
        }
      },
      error: (err) => {
        console.error('Payment failed or timed out:', err);
      }
    });
  }

  onLoadingModalClosed(event){

  }

  viewGuideDetails(guideInfo){
    this.router.navigateByUrl('pdf-guide');
  }

}
